import { RwdSvgIcon } from '@/components/common/rwdSvgIcon/RwdSvgIcon';
import { AudioPlayContext } from '@/contexts/AudioPlayContext';
import { Locale, getLocaleByCode } from '@/models/Locale';
import { Voice } from '@/models/Voice';
import { LanguageIcon, VoiceIcon } from '@/modules/lobby/svg';
import { getVHByRem, updateLocalStorageLanguage } from '@/utils/commonFunc';
import Grid from '@mui/material/Grid';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { DialogContext, SettingDialogProps } from '../..';
import { getSettingSoundState } from '../../selector';
import { soundSliceActions } from '../../slice/sound';
import { LanguageSelector } from './LanguageSelector';
import { VoiceSelector } from './VoiceSelector';
import './index.scss';
import { TickButton } from '@/modules/popup/svg';
const direction = 'column';
export const Language = (props: SettingDialogProps) => {
    const { setIsOpen } = props;
    const dispatch = useDispatch();

    const [language, setLanguage] = useState<string>(Locale.en_US.long);
    const [voiceSound, setVoiceSound] = useState<Voice>(Voice.English1);

    const { Voice2: currentVoice } = useSelector(getSettingSoundState);

    const { t, i18n } = useTranslation();

    const { playButtonAudio } = useContext(AudioPlayContext);
    const { setExtraCloseHandler } = useContext(DialogContext);
    useEffect(() => {
        // set current value to the form
        const dl = i18n.language;
        setLanguage(dl);
        setVoiceSound(currentVoice);
        setExtraCloseHandler(() => () => {});
    }, []);

    useEffect(() => {
        setExtraCloseHandler(() => () => {
            // update the local storage
            updateLocalStorageLanguage(getLocaleByCode('long', language).short);

            dispatch(
                soundSliceActions.updateAll({
                    // Music: musicSound,
                    Voice2: voiceSound,
                })
            );
        });
    }, [language, voiceSound]);

    const submitHandler = () => {
        // update the local storage
        updateLocalStorageLanguage(getLocaleByCode('long', language).short);
        // change the language
        i18n.changeLanguage(language);
        dispatch(
            soundSliceActions.updateAll({
                // Music: musicSound,
                Voice2: voiceSound,
            })
        );
        setIsOpen(false);
        playButtonAudio();
    };
    const languageChangeHandler = (lang: string) => {
        const defaultVoice = getLocaleByCode('long', lang).voice;
        setLanguage(lang);
        i18n.changeLanguage(lang);
        setVoiceSound(defaultVoice);
    };
    const cn = ['language-setting-container', 'mx-auto'];
    return (
        <Grid container className={cn.join(' ')}>
            <Grid item className="language-setting-combo-box">
                <Grid
                    container
                    direction={direction}
                    className="language-setting-combo-box-container"
                >
                    <Grid item className="title">
                        <LanguageIcon></LanguageIcon>
                        {t('setting.display_language')}
                    </Grid>
                    <Grid item>
                        <LanguageSelector
                            language={language}
                            handleChangeLanguage={languageChangeHandler}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item className="language-setting-combo-box">
                <Grid
                    container
                    direction={direction}
                    className="language-setting-combo-box-container"
                >
                    <Grid item className="title">
                        <VoiceIcon></VoiceIcon>
                        {t('setting.voice_language')}
                    </Grid>
                    <Grid item>
                        <VoiceSelector
                            voiceSound={voiceSound}
                            setVoiceSound={setVoiceSound}
                        />
                    </Grid>
                </Grid>
            </Grid>
            {false && (
                <Grid item className="language-setting-confirm-button">
                    <RwdSvgIcon vSize={3} hSize={getVHByRem(3)}>
                        <TickButton onClick={submitHandler} />
                    </RwdSvgIcon>
                </Grid>
            )}
        </Grid>
    );
};
